"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Integration = void 0;

var Integration =
/** @class */
function () {
  function Integration() {}

  Integration.prototype.IntegrationInvitationCreationType = function () {
    return [{
      slug: 'unconfirmed-no-email',
      name: 'Unconfirmed No Email',
      description: 'Add as Unconfirmed, email will not be sent.',
      isConfirmedNoEmail: false,
      isUnconfirmedNoEmail: true
    }, {
      slug: 'confirmed-no-email',
      name: 'Confirmed No Email',
      description: 'Add as Confirmed, email will not be sent.',
      isConfirmedNoEmail: true,
      isUnconfirmedNoEmail: false
    }];
  };

  Integration.prototype.IntegrationSettingType = function () {
    return [{
      slug: 'salesforce',
      name: 'Salesforce',
      description: null,
      isSalesforce: true,
      isMarketo: false
    }, {
      slug: 'marketo',
      name: 'Marketo',
      description: null,
      isSalesforce: false,
      isMarketo: true
    }];
  };

  Integration.prototype.UserAttributeInfoFieldType = function () {
    return [{
      slug: 'company',
      name: 'Company',
      description: null
    }, {
      slug: 'position',
      name: 'Position',
      description: null
    }, {
      slug: 'title',
      name: 'Title',
      description: null
    }, {
      slug: 'telephone',
      name: 'Telephone',
      description: null
    }, {
      slug: 'user-email-unsubscribe',
      name: 'Email Unsubscribe',
      description: null
    }, {
      slug: 'newCustomField',
      name: 'New Custom Field',
      description: null
    }];
  };

  return Integration;
}();

exports.Integration = Integration;